import request, { requestV2 } from 'store/common/utils';
export const getUnitsApi = (projectId, params, signal) => request({
    url: `/projects/${projectId}/units`,
    method: 'GET',
    params,
    signal,
});
export const downloadUnitsApi = (projectId) => request({
    url: `/projects/${projectId}/units/downloads`,
    method: 'POST',
    responseType: 'blob',
});
export const downloadFileApi = (url) => request({
    url,
    method: 'GET',
    responseType: 'blob',
    headers: {
        authorization: undefined,
        'x-api-locale': undefined,
    },
});
export const uploadUnitsApi = (projectId, data) => request({
    url: `/projects/${projectId}/units/import`,
    method: 'POST',
    headers: {
        'content-type': 'multipart/form-data',
    },
    data,
});
export const syncUnitsApi = (projectId, data) => request({
    url: `/projects/${projectId}/units/sync`,
    method: 'POST',
    data,
});
export const unitsScanApi = ({ projectId, data }) => request({
    url: `/projects/${projectId}/units/scan`,
    method: 'POST',
    headers: {
        'content-type': 'multipart/form-data',
    },
    data,
});
export const checkNumberAvailabilityApi = (data) => request({
    url: '/units/check-number-availability',
    method: 'POST',
    data,
});
export const getUnitPriceHistoryApi = (unitId) => request({
    url: `/units/${unitId}/price-history`,
    method: 'GET',
});
export const getUnitContactsApi = (unitId) => requestV2({
    url: `/units/${unitId}/contacts`,
    method: 'GET',
});
export const sendUnitContactMetricsApi = (unitId) => requestV2({
    url: `/metrics/units/${unitId}/contact`,
    method: 'POST',
});
export const deleteUnitsPlansApi = (projectId) => request({
    url: `/projects/${projectId}/unit-layouts`,
    method: 'DELETE',
});
export const deleteSoldOutUnitApi = (projectId, unitNumber) => request({
    url: `/projects/${projectId}/units/sold-out/${unitNumber}`,
    method: 'DELETE',
});
export const deleteUnitsStubBatchAdminApi = (projectId, { ids }, signal) => requestV2({
    url: `/projects/${projectId}/units/stub/delete-batch`,
    method: 'POST',
    data: { ids },
    signal,
    headers: { 'x-api-scope': 'admin' },
});
export const deleteUnitsStubAllAdminApi = (projectId, signal) => requestV2({
    url: `/projects/${projectId}/units/stub/delete-all`,
    method: 'POST',
    signal,
    headers: { 'x-api-scope': 'admin' },
});
